document.addEventListener('DOMContentLoaded', function () {

  const blocks = document.querySelectorAll('.footer-block');
  const breakpoint = 768;

  blocks.forEach(function (block) {

    const heading = block.querySelector('.footer-block__heading');
    const content = block.querySelector('.footer-block__details-content');

    if (!heading || !content) return;

    heading.addEventListener('click', function () {

      if (window.innerWidth > breakpoint) return;

      block.classList.toggle('is-open');

    });

  });

});

document.querySelectorAll('header-menu details').forEach(details => {
  const summary = details.querySelector('summary');

  // Hover open
  details.addEventListener('mouseenter', () => {
    details.setAttribute('open', '');
  });

  // Hover close
  details.addEventListener('mouseleave', () => {
    details.removeAttribute('open');
  });

  // Click handling
  summary.addEventListener('click', (e) => {
    const link = summary.dataset.href;

    // If summary has data-href → redirect
    if (link) {
      window.location.href = link;
      return;
    }

    // No link → prevent toggle
    e.preventDefault();
  });
});
